import { HelpCircle } from "@/template/icons/index.ts";
import * as S from "./styles.ts";
import { useState } from "react";

const Tooltip = ({ children }) => {
  const [visible, setVisible] = useState(false);

  const toggleTooltip = () => setVisible(!visible);

  return (
    <S.TooltipWrapper
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onClick={toggleTooltip}
    >
      <HelpCircle />
      <S.TooltipBubble>{children}</S.TooltipBubble>
    </S.TooltipWrapper>
  );
};

export default Tooltip;
